package com.imobly.imobly.api.dto

import kotlinx.serialization.Serializable

@Serializable
class EmailDTO(val email: String)